import { PageHeader } from "@/components/PageHeader";

type Props = {
  // Kept for API compatibility with existing callers; no longer rendered as a
  // redundant eyebrow now that the breadcrumb lives in the TopBar.
  eyebrow: string;
  title: string;
  body: string;
};

export function PlaceholderRoute({ title, body }: Props) {
  return (
    <div className="mx-auto max-w-[820px]">
      <PageHeader title={title} subtitle={body || undefined} />
      <div className="fade-up rounded-lg border border-dashed border-border bg-card/40 p-10 text-center">
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          nothing here yet
        </div>
        <p className="mt-2 text-[13px] text-muted-foreground">
          This screen will land in a follow-up ticket.
        </p>
      </div>
    </div>
  );
}
